<template>
    <div class="helpMain">
        <p class="titleMain">当前位置： <span>入驻企业</span></p>
        <div class="contextMain">
            <div class="listItem">
                <div v-for="item in list" :key="item.id" class="flex_box">
                    <div>
                        <p>{{ item.name }}</p>
                        <P class="expName">{{ item.sub_cate_name }}</P>
                    </div>
                    <p class="expName">{{ item.create_time }}</p>
                </div>
            </div>
            <div class="pagination">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="20"
                    :pager-count="11"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { getTimeDate } from '../../js/getTime.js'
export default{
    data(){
        return{
            list: '',
            hideOnSinglePage: true,
            total: 0
        }
    },
  
    methods: {
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            this.handleListcompany(val)
        },
        handleListcompany(val){
            let data = {
                pageNum: val,
                pageSize: 20
            }
            this.$store.dispatch('expert/listcompany',data)
                .then(res => {
                    this.list = res.data.items
                    this.total = res.data.total

                    this.list.forEach(item => {
                        item.create_time = getTimeDate(item.create_time)
                    });

                    if(this.total <= 20){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                })
        },
    },
    created(){
     
        this.handleListcompany(1)
    
    }
}
</script>
<style scoped lang="scss">
.helpMain{
    width: 1200px;min-height: calc(100vh - 190px);
    padding: 10px 10px;
    margin: 45px auto;
    .titleMain{
        margin-top: -45px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .contextMain{
        width: 100%;
        margin-top: 10px;
        background-color: #ffffff;
        .listItem{
            padding: 10px 20px;
            color: #333333;
            font-size: 18px;
            .flex_box{
                padding: 10px 20px 20px 20px;
                border-bottom: 0.5px solid #f2f2f2;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;
            
                p:nth-child(2){
                    margin-top: 5px;
                }
                .expName{
                    font-size: 16px;
                    color: #666666
                }
            }
        }
        .pagination{
            margin-top: 40px;
            text-align: right;
        }
    }
}
</style>